import { defineComponent as _defineComponent } from 'vue';
import Button from 'primevue/button';
import Sidebar from 'primevue/sidebar';
import CropManagementForm from './Form.vue';
import { computed, ref } from 'vue';
import { usePage } from '@inertiajs/inertia-vue3';
import { trans } from 'laravel-vue-i18n';
import { FertilizationMethod, WaterWithdrawal } from '../../../@types/Enums';
import { getEnumKeyByValue } from '../../../Services/Utils';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Details',
    setup(__props, { expose }) {
        expose();
        const formSidebarVisible = ref(false);
        const page = usePage();
        const cropManagement = computed(() => page.props.value.crop_management);
        const onSave = (cropManagement) => {
            page.props.value.crop_management = cropManagement;
            formSidebarVisible.value = false;
        };
        const __returned__ = { formSidebarVisible, page, cropManagement, onSave, get Button() { return Button; }, get Sidebar() { return Sidebar; }, CropManagementForm, get trans() { return trans; }, get FertilizationMethod() { return FertilizationMethod; }, get WaterWithdrawal() { return WaterWithdrawal; }, get getEnumKeyByValue() { return getEnumKeyByValue; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
